import { ShoesState } from 'src/types'

const leatherFrame = (ctx: CanvasRenderingContext2D | null, state: ShoesState) => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#383838'
  ctx.fillStyle = 'gray'
  ctx.beginPath()
  ctx.moveTo(11, 432)
  ctx.quadraticCurveTo(92, 477, 203, 502)
  ctx.quadraticCurveTo(299, 516, 397, 500)
  ctx.quadraticCurveTo(451, 487, 548, 489)
  ctx.quadraticCurveTo(718, 497, 850, 495) // 右端
  ctx.quadraticCurveTo(850, 504, 850, 504)
  ctx.quadraticCurveTo(687, 509, 547, 498)
  ctx.quadraticCurveTo(452, 498, 397, 509)
  ctx.quadraticCurveTo(299, 527, 203, 511)
  ctx.quadraticCurveTo(90, 489, 5, 439)
  ctx.quadraticCurveTo(5, 439, 11, 432)
  ctx.quadraticCurveTo
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}

const teeth1 = (ctx: CanvasRenderingContext2D | null, state: ShoesState, x: number, y: number) => {
  ctx.fillStyle = '#44463F'
  ctx.beginPath()
  ctx.moveTo(292 + x, 518 + y) //つま先＿左下
  ctx.quadraticCurveTo(292 + x, 537 + y, 292 + x, 537 + y)
  ctx.quadraticCurveTo(294 + x, 548 + y, 301 + x, 547 + y)
  ctx.quadraticCurveTo(309 + x, 552 + y, 313 + x, 543 + y)
  ctx.quadraticCurveTo(317 + x, 539 + y, 317 + x, 547 + y)
  ctx.quadraticCurveTo(328 + x, 547 + y, 332 + x, 540 + y)
  ctx.quadraticCurveTo(333 + x, 520 + y, 333 + x, 518 + y)
  ctx.quadraticCurveTo(292 + x, 516 + y, 292 + x, 518 + y)
  // ctx.quadraticCurveTo(
  ctx.stroke()
  ctx.fill()
  ctx.closePath()
}

const teeth2 = (ctx: CanvasRenderingContext2D | null, state: ShoesState, x: number, y: number) => {
  // 歯_先頭3
  ctx.fillStyle = '#44463F'
  ctx.beginPath()
  ctx.moveTo(679 + x, 504 + y) //つま先＿左下
  ctx.quadraticCurveTo(679 + x, 526 + y, 679 + x, 528 + y)
  ctx.quadraticCurveTo(691 + x, 542 + y, 698 + x, 530 + y)
  ctx.quadraticCurveTo(698 + x, 526 + y, 701 + x, 531 + y)
  ctx.quadraticCurveTo(702 + x, 537 + y, 698 + x, 533 + y)
  ctx.quadraticCurveTo(705 + x, 536 + y, 705 + x, 528 + y)
  ctx.quadraticCurveTo(704 + x, 507 + y, 704 + x, 504 + y)
  ctx.quadraticCurveTo(679 + x, 507 + y, 679 + x, 504 + y)
  // ctx.quadraticCurveTo(
  ctx.stroke()
  ctx.fill()
  ctx.closePath()
}

export const leatherSoleWithEva = (ctx: CanvasRenderingContext2D | null, state: ShoesState) => {
  // 歯_先頭1
  ctx.fillStyle = '#44463F'
  ctx.beginPath()
  ctx.moveTo(81, 475) //つま先＿左下
  ctx.quadraticCurveTo(73, 502, 73, 502)
  ctx.quadraticCurveTo(85, 504, 85, 504)
  ctx.quadraticCurveTo(90, 499, 96, 482)
  ctx.quadraticCurveTo(81, 475, 81, 475)
  // ctx.quadraticCurveTo(
  ctx.stroke()
  ctx.fill()
  ctx.closePath()

  teeth1(ctx, state, 0, 0)
  teeth2(ctx, state, -345, -5)

  teeth2(ctx, state, -100, -10)
  teeth1(ctx, state, 320, -15)

  teeth2(ctx, state, 90, -5)

  // ctx.lineWidth = 2.0
  // ctx.strokeStyle = 'red'
  // ctx.beginPath()
  // ctx.moveTo(11, 432)
  // ctx.quadraticCurveTo
  // ctx.stroke()
  // ctx.closePath()

  leatherFrame(ctx, state)
}
